import React, { useEffect, useState, useRef } from 'react';

import ReactModal from 'react-modal';

import { showRenewModalTimeout } from '../config';

const ExtendSessionModal = ({ logout, launchRefresh }) => {
  const [count, setCount] = useState(showRenewModalTimeout / 1000);

  let logoutTimer = useRef(null);
  let counter = useRef(null);

  useEffect(() => {
    logoutTimer.current = setTimeout(() => {
      logout();
    }, showRenewModalTimeout);

    counter.current = setInterval(() => {
      setCount((count) => count - 1);
    }, 1000);

    return () => {
      clearTimeout(logoutTimer.current);
      clearInterval(counter.current);
    };
  }, [logout]);

  const handleLogout = () => {
    logout();
    clearTimeout(logoutTimer.current);
    clearInterval(counter.current);
  };

  const handleExtend = () => {
    launchRefresh();
    clearTimeout(logoutTimer.current);
    clearInterval(counter.current);
  };

  return (
    <ReactModal isOpen={true} className="field-modal extend-session" contentLabel="bla blabla">
      <p>
        Your session is about to expire ({count >= 0 && count}s).
        <br />
        <br />
        Do you want to extend it?
      </p>
      <div className="extend-session-buttons">
        <button className="extend-session-buttons-item" onClick={handleLogout}>
          Logout
        </button>
        <button className="extend-session-buttons-item" onClick={handleExtend}>
          Extend Session
        </button>
      </div>
    </ReactModal>
  );
};

export default ExtendSessionModal;
